(() => {
  const scrollToReviews = (trigger) => {
    const target = document.getElementById('mmg-product-reviews');
    if (!target) return false;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    target.setAttribute('tabindex', '-1');
    window.setTimeout(() => target.focus({ preventScroll: true }), reduceMotion ? 0 : 520);
    try {
      history.replaceState(null, '', '#mmg-product-reviews');
    } catch (error) {
      // The scroll still works if the browser blocks URL updates in preview mode.
    }
    return true;
  };


  const initializeCourseOffers = (root = document) => {
    root.querySelectorAll('[data-mmg-course-offer]:not([data-mmg-course-initialized])').forEach((offer) => {
      offer.dataset.mmgCourseInitialized = 'true';
      const scope = offer.closest('[data-mmg-purchase-scope]') || document;
      const input = scope.querySelector('[data-quantity-input], input.quantity__input[name="quantity"]');
      const buttons = Array.from(offer.querySelectorAll('[data-mmg-course-qty]'));
      if (!input || !buttons.length) return;

      const updateSelection = () => {
        const quantity = Number.parseInt(input.value, 10) || 1;
        buttons.forEach((button) => {
          const selected = Number.parseInt(button.dataset.mmgCourseQty, 10) === quantity;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;
          input.value = button.dataset.mmgCourseQty;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
          updateSelection();
        });
      });

      input.addEventListener('input', updateSelection);
      input.addEventListener('change', updateSelection);
      updateSelection();
    });
  };

  initializeCourseOffers();
  document.addEventListener('shopify:section:load', (event) => initializeCourseOffers(event.target));

  document.addEventListener('click', (event) => {
    const reviewTrigger = event.target.closest('[data-mmg-reviews-link], [data-mmg-review-jump]');
    if (reviewTrigger) {
      event.preventDefault();
      scrollToReviews(reviewTrigger);
      return;
    }

    const filterTrigger = event.target.closest('[data-mmg-open-filters]');
    if (!filterTrigger) return;

    event.preventDefault();

    const filtersRoot = document.querySelector('#main-collection-filters');
    if (!filtersRoot) return;

    const targetLabel = (filterTrigger.dataset.mmgFilterTarget || '').trim().toLowerCase();
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const normalize = (value) => (value || '').trim().toLowerCase();
    const findTarget = (selector) => {
      const candidates = Array.from(filtersRoot.querySelectorAll(selector));
      if (!targetLabel) return candidates[0] || null;
      return candidates.find((details) => normalize(details.dataset.mmgFilterLabel) === targetLabel) || null;
    };

    document.querySelectorAll('[data-mmg-open-filters]').forEach((button) => {
      button.classList.toggle('is-active', button === filterTrigger);
    });

    if (isMobile) {
      const drawerDetails = filtersRoot.querySelector('.mobile-facets__disclosure');
      const drawerSummary = drawerDetails?.querySelector(':scope > summary');
      if (!drawerDetails || !drawerSummary) return;

      if (!drawerDetails.open) drawerSummary.click();
      if (!targetLabel) return;

      window.setTimeout(() => {
        const targetDetails = findTarget('.mobile-facets__details[data-mmg-filter-label]');
        const targetSummary = targetDetails?.querySelector(':scope > summary');
        if (targetDetails && targetSummary && !targetDetails.open) targetSummary.click();
      }, 180);
      return;
    }

    const targetDetails = findTarget('.facets__disclosure[data-mmg-filter-label], .facets__disclosure-vertical[data-mmg-filter-label]');
    const targetSummary = targetDetails?.querySelector(':scope > summary');
    if (!targetDetails || !targetSummary) return;

    filtersRoot.querySelectorAll('.facets__disclosure[open], .facets__disclosure-vertical[open]').forEach((details) => {
      if (details !== targetDetails) details.removeAttribute('open');
    });

    if (!targetDetails.open) targetSummary.click();
    targetSummary.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    window.setTimeout(() => targetSummary.focus({ preventScroll: true }), 350);
  });
})();
